module.exports = __webpack_public_path__ + "39c9e96785bc8c2a663f276d5a8ddc60.gif";